module.exports = __webpack_public_path__ + "img/cargar.1dbe987a.svg";